import { useDebounce } from '@uidotdev/usehooks';
import { isEqual } from 'lodash';
import { FC, useEffect, useRef, useState } from 'react';

import { TextField, useMediaQuery } from '@mui/material';
import { Stack, Theme } from '@mui/system';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';

import OperatorTooltip from './OperatorTooltip';

const FilterInput: FC<GridFilterInputValueProps> = (props) => {
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const { item, applyValue, apiRef } = props;

  const [inputValue, setInputValue] = useState((item.value as string) || '');

  const inputValueDebounced = useDebounce(inputValue, 500);
  const inputValueDebouncedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isEqual(inputValueDebounced, inputValueDebouncedRef.current)) {
      inputValueDebouncedRef.current = inputValueDebounced;

      applyValue({ ...item, value: inputValueDebounced });
    }
  }, [applyValue, inputValue, inputValueDebounced, item]);

  let inputType: 'text' | 'number' = 'text';

  ['>', '<', '>=', '<='].includes(item.operator)
    ? (inputType = 'number')
    : (inputType = 'text');

  return (
    <Stack direction='row'>
      {matches && <OperatorTooltip gridFilterItem={item} />}

      <TextField
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        size='medium'
        variant='standard'
        label={apiRef.current.getLocaleText('filterPanelInputLabel')}
        placeholder={apiRef.current.getLocaleText(
          'filterPanelInputPlaceholder',
        )}
        type={inputType}
      />
    </Stack>
  );
};

export default FilterInput;
